/* eslint-disable react/jsx-one-expression-per-line */
import React, { useContext, useEffect, useState } from 'react';
import { Button, Card, Row, Col } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { FaExternalLinkAlt } from 'react-icons/fa'; // ボタンにアイコンを追加するためのライブラリ
import { makeStyles } from '@material-ui/core';
import { useSetRecoilState } from 'recoil';
import AuthenticatedContext from '../../context/AuthenticatedContext';
import { CustContact } from '../../models/data/LoginCustomer';
import { pathnames, requestCustContact } from '../../api';
import { routeName } from '../../App';
import DataDisp from './datadisp';
import { pageTitle } from '../../context/PageRecoil';
import useErrorHandling from '../errorCheck';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
  },
  col: {
    wordBreak: 'break-all', // 文字が折り返す
    whiteSpace: 'break-spaces', // 改行文字で改行するようになる(空白で突き抜けない)
  },
  colItem: {
    maxWidth: '100px',
    height: '50px',
    textAlign: 'right',
    backgroundColor: '#f4f4f4',
    borderRadius: '5px 0 0 5px',
    boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
    border: '1px solid #ccc',
    padding: '1px',
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      right: '0',
      top: 0,
      bottom: 0,
      width: '10px', // 帯の幅
      backgroundColor: '#0050a6', // '#0091d7', // 帯の色
    },
  },
  colValue: {
    maxWidth: '400px',
    height: '50px',
    backgroundColor: '#f4f4f4',
    // borderRadius: '5px',
    boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
    border: '1px solid #ccc',
    padding: '1px',
    paddingLeft: '5px',
  },
  oddRow: {
    backgroundColor: '#e0e0e0',
  },
  evenRow: {
    backgroundColor: '#f4f4f4',
  },
  cell: {
    position: 'relative',
    paddingRight: '1px',
    '&::after': {
      content: '""',
      position: 'absolute',
      right: '0',
      top: '10%', // 上側の隙間のサイズを調整
      bottom: '10%', // 下側の隙間のサイズを調整
      width: '1px',
      backgroundColor: '#ffffff', // 縦線の色
    },
  },
}));
/**
 * メニュー画面
 */
const Menu: React.FunctionComponent = () => {
  const authContext = useContext(AuthenticatedContext); // ログインユーザの情報を取得
  const classes = useStyles();
  const history = useHistory();
  const { errorCheck } = useErrorHandling(); // エラー処理
  const urlManual = history.createHref({
    pathname: pathnames.manual,
  });

  const setPageTitle = useSetRecoilState(pageTitle);
  React.useEffect(() => {
    return setPageTitle({ pageTitle: 'メニュー' }); // ページのタイトルを設定
  }, [setPageTitle]);

  const width1 = 3; // 担当者連絡先の項目名の幅
  const width2 = 10 - width1; // 担当者連絡先の項目の幅

  const [custContact, setCustContact] = useState<CustContact | null>(null);
  const urlContact = history.createHref({ pathname: pathnames.contact });
  useEffect(() => {
    requestCustContact(urlContact, { id: authContext.loginCustomer?.loginId })
      .then((response) => {
        setCustContact(response.data);
      })
      .catch((error) => {
        errorCheck(error); // エラー内容を確認
      });
  }, []); // 空の配列を依存関係リストとして使用すると、エフェクトはマウント後に一度だけ実行され、クリーンアップ（アンマウント時）にも一度だけ実行されます。

  return (
    <div className={classes.root}>
      <DataDisp userdata={authContext} />
      <div className="mt-3 mb-5" style={{ width: '600px' }}>
        <Button
          variant="primary"
          className="mr-3"
          onClick={() => history.push(routeName.eqList)}
        >
          設備一覧
        </Button>
        {/* <Button
          target="_blank"
          variant="primary"
          className="mr-3"
          // eslint-disable-next-line prettier/prettier
          onClick={() => window.open('https://www.eng-mainte.jp/CLOUD_EQ_INFO_MANAGE')}
        >
          <FaExternalLinkAlt /> ドキュメント一覧
        </Button> */}
        {/* <Button
          // href="https://www.eng-mainte.jp/mec-bbs"
          target="_blank"
          variant="primary"
          className="mr-3"
          onClick={() => window.open('https://www.eng-mainte.jp/mec-bbs')}
        >
          <FaExternalLinkAlt /> 掲示板
        </Button> */}
        <Button
          target="_blank"
          variant="primary"
          // eslint-disable-next-line prettier/prettier
          onClick={() => window.open('https://www.eng-mainte-cl.jp/device-data')}
        >
          <FaExternalLinkAlt /> 計測装置データ
        </Button>
      </div>

      <div className="mt-3">
        <Card style={{ width: '600px' }}>
          <Card.Header style={{ fontSize: '1rem' }}>担当者連絡先</Card.Header>
          <Card.Body>
            <Row className="align-items-center border-bottom pb-2">
              <Col xs={width1} className="text-right border-right">
                担当者
              </Col>
              <Col xs={width2} className={classes.col}>
                {custContact?.customerUserName ?? ''}
              </Col>
            </Row>
            <Row className="align-items-center border-bottom pb-2 pt-2">
              <Col xs={width1} className="text-right border-right">
                TEL
              </Col>
              <Col xs={width2} className={classes.col}>
                {custContact?.customerTel ?? ''}
              </Col>
            </Row>
            <Row className="align-items-center pt-2">
              <Col xs={width1} className="text-right border-right">
                メール
              </Col>
              <Col xs={width2} className={classes.col}>
                {custContact?.customerEmail ?? ''}
              </Col>
            </Row>
          </Card.Body>
        </Card>
        <div className="mt-5">
          <a href={urlManual} target="_blank" rel="noopener noreferrer">
            説明書を開く
          </a>
        </div>
      </div>
    </div>
  );
};

export default Menu;
